"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Correlator = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("../utils/utils");
var jquery_1 = tslib_1.__importDefault(require("jquery"));
var Correlator = /** @class */ (function () {
    function Correlator() {
        if (this.correlationId === null || this.correlationId === undefined) {
            this.correlationId = utils_1.Guid.create();
            if (jquery_1.default != null && jquery_1.default != undefined && jquery_1.default.ajaxSetup != null && jquery_1.default.ajaxSetup != undefined) {
                jquery_1.default.ajaxSetup({
                    headers: { "X-CorrelationId": this.correlationId }
                });
            }
        }
    }
    /*
    * method to get correation-id
    */
    Correlator.prototype.getCorrelationId = function () {
        return this.correlationId;
    };
    /*
    * method to set correation-id
    */
    Correlator.prototype.setCorrelationId = function (newId) {
        this.correlationId = newId;
    };
    /*
    * method to renew correation-id
    */
    Correlator.prototype.renewCorrelationId = function () {
        var tmp = utils_1.Guid.create();
        this.setCorrelationId(tmp);
        if (jquery_1.default != null && jquery_1.default != undefined && jquery_1.default.ajaxSetup != null && jquery_1.default.ajaxSetup != undefined) {
            jquery_1.default.ajaxSetup({
                headers: { "X-CorrelationId": this.correlationId }
            });
        }
        return this.correlationId;
    };
    /*
    * method to get sub-corelation-id
    */
    Correlator.prototype.getSubCorrelationId = function () {
        return this.subCorelationId;
    };
    /*
    * method to set sub-corelation-id
    */
    Correlator.prototype.setSubCorrelationId = function (newId) {
        this.subCorelationId = newId;
    };
    /*
    * method to renew sub-corelation-id
    */
    Correlator.prototype.renewSubCorrelationId = function () {
        var tmp = utils_1.Guid.create();
        this.setSubCorrelationId(tmp);
        return this.subCorelationId;
    };
    return Correlator;
}());
exports.Correlator = Correlator;
//# sourceMappingURL=Correlator.js.map